<template>
  <div :id="groupId" class="accordion-item" :class="{ 'is-active': active, 'is-electron': $isElectron }">
    <div class="accordion-item-title">
      <div @click="toggle" class="accordion-item-trigger">
        <slot name="title"></slot>
        <span class="accordion-item-trigger-icon">
          <svg width="11" height="5" viewBox="0 0 11 5" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10.0296 5L10.5 4.57007L5.50018 -4.37098e-07L0.5 4.57007L0.970392 5L5.50053 0.85986L10.0296 5Z"
              fill="#070A14"
            />
          </svg>
        </span>
      </div>
    </div>
    <transition
      name="accordion-item"
      @enter="startTransition"
      @after-enter="endTransition"
      @before-leave="startTransition"
      @after-leave="endTransition"
    >
      <div v-if="active" class="accordion-item-content">
        <slot name="content"></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'MenuAccordion',
  props: ['multiple', 'groupId', 'title', 'isOpened'],
  data() {
    return {
      active: false,
    };
  },
  methods: {
    toggle() {
      if (this.multiple) this.active = !this.active;
      else {
        this.$parent.$children.forEach((item, i) => {
          if (this.$el.id == item.$el.id) this.active = !this.active;
          else item.active = false;
        });
      }
    },

    startTransition(el) {
      el.style.height = el.scrollHeight + 'px';
    },

    endTransition(el) {
      el.style.height = '';
    },
  },
  mounted() {
    if (this.isOpened) {
      this.active = true;
    }
  },
};
</script>

<style scoped lang="scss">
.accordion-item {
  --darkBlue: #343a40;
  &.is-electron {
    --darkBlue: #fff;
  }
}

.accordion-item-trigger {
  width: 100%;
  text-align: left;
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  padding-left: 24px;
  padding-right: 15px;
  height: 40px;
  align-items: center;
  justify-content: center;
  color: var(--darkBlue);
  border-left: 3px solid transparent;
  font-size: 12px;
  &:hover {
    background: rgba(248, 248, 248, 0.6);
  }
}

.accordion-item-trigger-icon {
  $size: 10px;
  width: 10px;
  margin-left: auto;
  svg {
    transition: all ease-in 0.2s;
    transform: rotate(90deg);
  }
}

.accordion-item.is-active {
  .accordion-item-trigger {
    background: #e8e8e8;
    border-left: 3px solid var(--color3);
    font-weight: bold;
  }
  .accordion-item-trigger-icon {
    svg {
      transform: rotate(0deg) !important;
    }
  }
}

.accordion-item.is-electron {
  .accordion-item-trigger {
    &:hover {
      background: rgba(100, 118, 162, 0.7) !important;
    }
  }
}
.is-electron {
  .accordion-item-trigger-icon path {
    fill: #f1f4fb !important;
  }
}
.accordion-item.is-active.is-electron {
  .accordion-item-trigger {
    background: #2a3550;
    border-left: 3px solid var(--color3);
    font-weight: bold;
    color: #f1f4fb;
  }
}

.accordion-item-content {
  background: #f8f8f8;
  overflow: hidden;
}

.accordion-item-enter-active,
.accordion-item-leave-active {
  will-change: height;
  transition: height 0.2s ease;
}
.accordion-item-enter,
.accordion-item-leave-to {
  height: 0 !important;
}
</style>
